export const SESSION_HEADER_NAME = 'x-mcp-session-id';
export const SESSION_COOKIE_NAME = 'mcp-session-id';

export function parseSessionIdFromCookieHeader(
  cookieHeader: string | undefined
): string | undefined {
  if (!cookieHeader) return undefined;
  for (const part of cookieHeader.split(';')) {
    const eq = part.indexOf('=');
    if (eq < 0) continue;
    if (part.slice(0, eq).trim() !== SESSION_COOKIE_NAME) continue;
    const value = part.slice(eq + 1).trim();
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }
  return undefined;
}
